<template>
    <div class="car-image-gallery-static">
        <div class="image image--full-width">
            <img :src="mainPhoto?.path_small || noPhotoImage" />
        </div>

        <div class="images-row">
            <div
                v-for="(photo, index) in additionalPhotos"
                :key="index"
                class="image image--small"
            >
                <img :src="photo.path_small" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import noPhotoImageDefault from '@/assets/images/cars/no-photo.webp';

    import { computed, PropType } from 'vue';

    import { CarPhoto } from '@/types/car.type.ts';

    const { photos, noPhotoImage } = defineProps({
        photos: {
            type: Array as PropType<CarPhoto[]>,
            default: [],
        },
        noPhotoImage: {
            type: String,
            default: noPhotoImageDefault,
        },
    });

    const mainPhoto = computed<CarPhoto | null>(() => {
        if (photos.length === 0) {
            return null;
        }

        return photos[0];
    });

    const additionalPhotos = computed<CarPhoto[]>(() => {
        return photos.slice(1, 4);
    });

</script>

<style scoped lang="scss">
    @use './CarImageGalleryStatic.scss' as *;
</style>
